import { Grid } from '@material-ui/core';
import { useQuoteField } from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import { FormRowGrid, GridRowProps } from 'Quoting/components/shared/GridRow';
import { QuoteFormElement } from 'Quoting/components/shared/QuoteFormElement';
import { FormWrapper } from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ReducerState } from 'rootReducer';
import { GPLUCoverageCode } from '../../../PlanTemplates/GWL/gpluConstants';
import { getGPLUFundingStructurePropertyPaths } from '../PropertyPaths';

export const GPLUSpouseFundingStructureBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = getGPLUFundingStructurePropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-e27aeccd-9daf-40e7-a47d-2bae8c862892'},
      items: [
        {
          key: propertyPaths.contributionTypeCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              label="Contribution Type"
              id={propertyPaths.contributionTypeCd}
              value={getQuoteFieldValue(propertyPaths.contributionTypeCd)}
              onChange={e => updateQuoteFieldValue(propertyPaths.contributionTypeCd, e.target.value)}
              dropdownVariant="AttributeValue"
              searchKey="GPLUBenefitReducedFundingStructure.contributionTypeCd"
              coverageCode={GPLUCoverageCode.SPOUSE_WHOLE_LIFE}
              disabled
              required
            />
          ),
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Funding Structure" collapsible withSeparator>
      <Grid container alignItems="center">
        <FormRowGrid rows={rows} />
      </Grid>
    </FormWrapper>
  );
};
